// Complete form structure extracted from MS Forms
// Text values are now i18n keys (resolved at render time via the 'survey' namespace)
export const formConfig = {
  titleKey: "title",
  descriptionKey: "description",

  sections: [
    { id: "instructions", titleKey: "sections.instructions", type: "info" },
    { id: "profile", titleKey: "sections.profile", type: "profile" },
    { id: "dyadic", titleKey: "sections.dyadic", type: "matrix" },
    { id: "personality", titleKey: "sections.personality", type: "matrix" },
  ],

  instructionsKey: "instructions",

  profileQuestions: [
    { id: "q1", titleKey: "profile.q1.title", type: "text", required: true },
    { id: "q2", titleKey: "profile.q2.title", type: "text", inputType: "email", required: true },
    { id: "q3", titleKey: "profile.q3.title", type: "choice", required: true, optionsKey: "profile.q3.options" },
    { id: "q4", titleKey: "profile.q4.title", type: "text", inputType: "number", required: true, min: 18, max: 120 },
    { id: "q5", titleKey: "profile.q5.title", type: "text", required: true },
    { id: "q6", titleKey: "profile.q6.title", type: "text", inputType: "email", required: true },
    { id: "q7", titleKey: "profile.q7.title", type: "choice", required: true, optionsKey: "profile.q7.options" },
    { id: "q8", titleKey: "profile.q8.title", type: "choice", required: true, optionsKey: "profile.q8.options" },
    { id: "q9", titleKey: "profile.q9.title", type: "choice", required: true, optionsKey: "profile.q9.options" },
    { id: "q10", titleKey: "profile.q10.title", type: "choice", required: true, optionsKey: "profile.q10.options" },
    { id: "q11", titleKey: "profile.q11.title", type: "choice", required: true, optionsKey: "profile.q11.options" },
    { id: "q12", titleKey: "profile.q12.title", type: "choice", required: true, optionsKey: "profile.q12.options" },
    { id: "q13", titleKey: "profile.q13.title", type: "choice", required: true, allowMultiple: true, optionsKey: "profile.q13.options" },
  ],

  matrixGroups: [
    // Dyadic Coping Inventory
    {
      id: "dci1",
      section: "dyadic",
      titleKey: "dci.dci1.title",
      required: true,
      responseScaleKey: "scales.dci",
      questions: [
        { id: "dci1_1", titleKey: "dci.dci1.dci1_1" },
        { id: "dci1_2", titleKey: "dci.dci1.dci1_2" },
        { id: "dci1_3", titleKey: "dci.dci1.dci1_3" },
        { id: "dci1_4", titleKey: "dci.dci1.dci1_4" },
      ]
    },
    {
      id: "dci2",
      section: "dyadic",
      titleKey: "dci.dci2.title",
      required: true,
      responseScaleKey: "scales.dci",
      questions: [
        { id: "dci2_1", titleKey: "dci.dci2.dci2_1" },
        { id: "dci2_2", titleKey: "dci.dci2.dci2_2" },
        { id: "dci2_3", titleKey: "dci.dci2.dci2_3" },
        { id: "dci2_4", titleKey: "dci.dci2.dci2_4" },
        { id: "dci2_5", titleKey: "dci.dci2.dci2_5" },
        { id: "dci2_6", titleKey: "dci.dci2.dci2_6" },
        { id: "dci2_7", titleKey: "dci.dci2.dci2_7" },
        { id: "dci2_8", titleKey: "dci.dci2.dci2_8" },
        { id: "dci2_9", titleKey: "dci.dci2.dci2_9" },
        { id: "dci2_10", titleKey: "dci.dci2.dci2_10" },
        { id: "dci2_11", titleKey: "dci.dci2.dci2_11" },
      ]
    },
    {
      id: "dci3",
      section: "dyadic",
      titleKey: "dci.dci3.title",
      required: true,
      responseScaleKey: "scales.dci",
      questions: [
        { id: "dci3_1", titleKey: "dci.dci3.dci3_1" },
        { id: "dci3_2", titleKey: "dci.dci3.dci3_2" },
        { id: "dci3_3", titleKey: "dci.dci3.dci3_3" },
        { id: "dci3_4", titleKey: "dci.dci3.dci3_4" },
      ]
    },
    {
      id: "dci4",
      section: "dyadic",
      titleKey: "dci.dci4.title",
      required: true,
      responseScaleKey: "scales.dci",
      questions: [
        { id: "dci4_1", titleKey: "dci.dci4.dci4_1" },
        { id: "dci4_2", titleKey: "dci.dci4.dci4_2" },
        { id: "dci4_3", titleKey: "dci.dci4.dci4_3" },
        { id: "dci4_4", titleKey: "dci.dci4.dci4_4" },
        { id: "dci4_5", titleKey: "dci.dci4.dci4_5" },
        { id: "dci4_6", titleKey: "dci.dci4.dci4_6" },
        { id: "dci4_7", titleKey: "dci.dci4.dci4_7" },
        { id: "dci4_8", titleKey: "dci.dci4.dci4_8" },
        { id: "dci4_9", titleKey: "dci.dci4.dci4_9" },
        { id: "dci4_10", titleKey: "dci.dci4.dci4_10" },
        { id: "dci4_11", titleKey: "dci.dci4.dci4_11" },
      ]
    },
    {
      id: "dci5",
      section: "dyadic",
      titleKey: "dci.dci5.title",
      required: true,
      responseScaleKey: "scales.dci",
      questions: [
        { id: "dci5_1", titleKey: "dci.dci5.dci5_1" },
        { id: "dci5_2", titleKey: "dci.dci5.dci5_2" },
        { id: "dci5_3", titleKey: "dci.dci5.dci5_3" },
        { id: "dci5_4", titleKey: "dci.dci5.dci5_4" },
        { id: "dci5_5", titleKey: "dci.dci5.dci5_5" },
      ]
    },
    {
      id: "dci6",
      section: "dyadic",
      titleKey: "dci.dci6.title",
      required: true,
      responseScaleKey: "scales.dci",
      questions: [
        { id: "dci6_1", titleKey: "dci.dci6.dci6_1" },
        { id: "dci6_2", titleKey: "dci.dci6.dci6_2" },
      ]
    },
    // Personality Inventory
    {
      id: "pi1",
      section: "personality",
      titleKey: "personality.pi1.title",
      required: true,
      responseScaleKey: "scales.personality",
      questions: [
        { id: "pi1_1", titleKey: "personality.pi1.pi1_1" },
        { id: "pi1_2", titleKey: "personality.pi1.pi1_2" },
        { id: "pi1_3", titleKey: "personality.pi1.pi1_3" },
        { id: "pi1_4", titleKey: "personality.pi1.pi1_4" },
        { id: "pi1_5", titleKey: "personality.pi1.pi1_5" },
        { id: "pi1_6", titleKey: "personality.pi1.pi1_6" },
        { id: "pi1_7", titleKey: "personality.pi1.pi1_7" },
        { id: "pi1_8", titleKey: "personality.pi1.pi1_8" },
        { id: "pi1_9", titleKey: "personality.pi1.pi1_9" },
        { id: "pi1_10", titleKey: "personality.pi1.pi1_10" },
        { id: "pi1_11", titleKey: "personality.pi1.pi1_11" },
        { id: "pi1_12", titleKey: "personality.pi1.pi1_12" },
        { id: "pi1_13", titleKey: "personality.pi1.pi1_13" },
        { id: "pi1_14", titleKey: "personality.pi1.pi1_14" },
        { id: "pi1_15", titleKey: "personality.pi1.pi1_15" },
        { id: "pi1_16", titleKey: "personality.pi1.pi1_16" },
        { id: "pi1_17", titleKey: "personality.pi1.pi1_17" },
        { id: "pi1_18", titleKey: "personality.pi1.pi1_18" },
        { id: "pi1_19", titleKey: "personality.pi1.pi1_19" },
        { id: "pi1_20", titleKey: "personality.pi1.pi1_20" },
      ]
    },
    {
      id: "pi2",
      section: "personality",
      titleKey: "personality.pi2.title",
      required: true,
      responseScaleKey: "scales.personality",
      questions: [
        { id: "pi2_1", titleKey: "personality.pi2.pi2_1" },
        { id: "pi2_2", titleKey: "personality.pi2.pi2_2" },
        { id: "pi2_3", titleKey: "personality.pi2.pi2_3" },
        { id: "pi2_4", titleKey: "personality.pi2.pi2_4" },
        { id: "pi2_5", titleKey: "personality.pi2.pi2_5" },
        { id: "pi2_6", titleKey: "personality.pi2.pi2_6" },
        { id: "pi2_7", titleKey: "personality.pi2.pi2_7" },
        { id: "pi2_8", titleKey: "personality.pi2.pi2_8" },
        { id: "pi2_9", titleKey: "personality.pi2.pi2_9" },
        { id: "pi2_10", titleKey: "personality.pi2.pi2_10" },
        { id: "pi2_11", titleKey: "personality.pi2.pi2_11" },
        { id: "pi2_12", titleKey: "personality.pi2.pi2_12" },
        { id: "pi2_13", titleKey: "personality.pi2.pi2_13" },
        { id: "pi2_14", titleKey: "personality.pi2.pi2_14" },
        { id: "pi2_15", titleKey: "personality.pi2.pi2_15" },
        { id: "pi2_16", titleKey: "personality.pi2.pi2_16" },
        { id: "pi2_17", titleKey: "personality.pi2.pi2_17" },
        { id: "pi2_18", titleKey: "personality.pi2.pi2_18" },
        { id: "pi2_19", titleKey: "personality.pi2.pi2_19" },
        { id: "pi2_20", titleKey: "personality.pi2.pi2_20" },
      ]
    },
    {
      id: "pi3",
      section: "personality",
      titleKey: "personality.pi3.title",
      required: true,
      responseScaleKey: "scales.personality",
      questions: [
        { id: "pi3_1", titleKey: "personality.pi3.pi3_1" },
        { id: "pi3_2", titleKey: "personality.pi3.pi3_2" },
        { id: "pi3_3", titleKey: "personality.pi3.pi3_3" },
        { id: "pi3_4", titleKey: "personality.pi3.pi3_4" },
        { id: "pi3_5", titleKey: "personality.pi3.pi3_5" },
        { id: "pi3_6", titleKey: "personality.pi3.pi3_6" },
        { id: "pi3_7", titleKey: "personality.pi3.pi3_7" },
        { id: "pi3_8", titleKey: "personality.pi3.pi3_8" },
        { id: "pi3_9", titleKey: "personality.pi3.pi3_9" },
        { id: "pi3_10", titleKey: "personality.pi3.pi3_10" },
        { id: "pi3_11", titleKey: "personality.pi3.pi3_11" },
        { id: "pi3_12", titleKey: "personality.pi3.pi3_12" },
        { id: "pi3_13", titleKey: "personality.pi3.pi3_13" },
        { id: "pi3_14", titleKey: "personality.pi3.pi3_14" },
        { id: "pi3_15", titleKey: "personality.pi3.pi3_15" },
        { id: "pi3_16", titleKey: "personality.pi3.pi3_16" },
        { id: "pi3_17", titleKey: "personality.pi3.pi3_17" },
        { id: "pi3_18", titleKey: "personality.pi3.pi3_18" },
        { id: "pi3_19", titleKey: "personality.pi3.pi3_19" },
        { id: "pi3_20", titleKey: "personality.pi3.pi3_20" },
      ]
    },
    {
      id: "pi4",
      section: "personality",
      titleKey: "personality.pi4.title",
      required: true,
      responseScaleKey: "scales.personality",
      questions: [
        { id: "pi4_1", titleKey: "personality.pi4.pi4_1" },
        { id: "pi4_2", titleKey: "personality.pi4.pi4_2" },
        { id: "pi4_3", titleKey: "personality.pi4.pi4_3" },
        { id: "pi4_4", titleKey: "personality.pi4.pi4_4" },
        { id: "pi4_5", titleKey: "personality.pi4.pi4_5" },
        { id: "pi4_6", titleKey: "personality.pi4.pi4_6" },
        { id: "pi4_7", titleKey: "personality.pi4.pi4_7" },
        { id: "pi4_8", titleKey: "personality.pi4.pi4_8" },
        { id: "pi4_9", titleKey: "personality.pi4.pi4_9" },
        { id: "pi4_10", titleKey: "personality.pi4.pi4_10" },
        { id: "pi4_11", titleKey: "personality.pi4.pi4_11" },
        { id: "pi4_12", titleKey: "personality.pi4.pi4_12" },
        { id: "pi4_13", titleKey: "personality.pi4.pi4_13" },
        { id: "pi4_14", titleKey: "personality.pi4.pi4_14" },
        { id: "pi4_15", titleKey: "personality.pi4.pi4_15" },
        { id: "pi4_16", titleKey: "personality.pi4.pi4_16" },
        { id: "pi4_17", titleKey: "personality.pi4.pi4_17" },
        { id: "pi4_18", titleKey: "personality.pi4.pi4_18" },
        { id: "pi4_19", titleKey: "personality.pi4.pi4_19" },
        { id: "pi4_20", titleKey: "personality.pi4.pi4_20" },
      ]
    },
    {
      id: "pi5",
      section: "personality",
      titleKey: "personality.pi5.title",
      required: true,
      responseScaleKey: "scales.personality",
      questions: [
        { id: "pi5_1", titleKey: "personality.pi5.pi5_1" },
        { id: "pi5_2", titleKey: "personality.pi5.pi5_2" },
        { id: "pi5_3", titleKey: "personality.pi5.pi5_3" },
        { id: "pi5_4", titleKey: "personality.pi5.pi5_4" },
        { id: "pi5_5", titleKey: "personality.pi5.pi5_5" },
        { id: "pi5_6", titleKey: "personality.pi5.pi5_6" },
        { id: "pi5_7", titleKey: "personality.pi5.pi5_7" },
        { id: "pi5_8", titleKey: "personality.pi5.pi5_8" },
        { id: "pi5_9", titleKey: "personality.pi5.pi5_9" },
        { id: "pi5_10", titleKey: "personality.pi5.pi5_10" },
        { id: "pi5_11", titleKey: "personality.pi5.pi5_11" },
        { id: "pi5_12", titleKey: "personality.pi5.pi5_12" },
        { id: "pi5_13", titleKey: "personality.pi5.pi5_13" },
        { id: "pi5_14", titleKey: "personality.pi5.pi5_14" },
        { id: "pi5_15", titleKey: "personality.pi5.pi5_15" },
        { id: "pi5_16", titleKey: "personality.pi5.pi5_16" },
        { id: "pi5_17", titleKey: "personality.pi5.pi5_17" },
        { id: "pi5_18", titleKey: "personality.pi5.pi5_18" },
        { id: "pi5_19", titleKey: "personality.pi5.pi5_19" },
        { id: "pi5_20", titleKey: "personality.pi5.pi5_20" },
      ]
    },
    {
      id: "pi6",
      section: "personality",
      titleKey: "personality.pi6.title",
      required: true,
      responseScaleKey: "scales.personality",
      questions: [
        { id: "pi6_1", titleKey: "personality.pi6.pi6_1" },
        { id: "pi6_2", titleKey: "personality.pi6.pi6_2" },
        { id: "pi6_3", titleKey: "personality.pi6.pi6_3" },
        { id: "pi6_4", titleKey: "personality.pi6.pi6_4" },
        { id: "pi6_5", titleKey: "personality.pi6.pi6_5" },
        { id: "pi6_6", titleKey: "personality.pi6.pi6_6" },
        { id: "pi6_7", titleKey: "personality.pi6.pi6_7" },
        { id: "pi6_8", titleKey: "personality.pi6.pi6_8" },
        { id: "pi6_9", titleKey: "personality.pi6.pi6_9" },
        { id: "pi6_10", titleKey: "personality.pi6.pi6_10" },
        { id: "pi6_11", titleKey: "personality.pi6.pi6_11" },
        { id: "pi6_12", titleKey: "personality.pi6.pi6_12" },
        { id: "pi6_13", titleKey: "personality.pi6.pi6_13" },
        { id: "pi6_14", titleKey: "personality.pi6.pi6_14" },
        { id: "pi6_15", titleKey: "personality.pi6.pi6_15" },
        { id: "pi6_16", titleKey: "personality.pi6.pi6_16" },
        { id: "pi6_17", titleKey: "personality.pi6.pi6_17" },
        { id: "pi6_18", titleKey: "personality.pi6.pi6_18" },
        { id: "pi6_19", titleKey: "personality.pi6.pi6_19" },
        { id: "pi6_20", titleKey: "personality.pi6.pi6_20" },
      ]
    },
  ],
}

// Helper to build steps for wizard
// Note: steps carry titleKey (not title). Components resolve via i18n at render time.
export function buildFormSteps() {
  const steps = [
    { type: 'instructions', titleKey: 'sections.instructions', section: 'intro' },
    { type: 'profile', titleKey: 'sections.profile', section: 'profile', data: formConfig.profileQuestions },
  ]

  // Add dyadic coping groups
  formConfig.matrixGroups
    .filter(g => g.section === 'dyadic')
    .forEach(group => {
      steps.push({ type: 'matrix', titleKey: group.titleKey, section: 'dyadic', data: group })
    })

  // Add personality groups
  formConfig.matrixGroups
    .filter(g => g.section === 'personality')
    .forEach(group => {
      steps.push({ type: 'matrix', titleKey: group.titleKey, section: 'personality', data: group })
    })

  return steps
}

// Calculate total questions
export function getTotalQuestions() {
  const profileCount = formConfig.profileQuestions.length
  const matrixCount = formConfig.matrixGroups.reduce((sum, g) => sum + g.questions.length, 0)
  return profileCount + matrixCount
}
